export default __webpack_public_path__ + "static/media/tickets.6db95ece.png";